import cn from 'classnames';
import {ReactElement} from 'react';

interface ILocationDetail {
  state?: any;
  city?: any;
  address?: string;
  customClassName?: string;
  icon?: ReactElement;
}

const Location = ({
  state,
  city,
  address,
  customClassName,
  icon,
}: ILocationDetail) => {
  return (
    <div
      className={cn('flex items-center gap-1 text-gray-800 ', customClassName)}
    >
      {icon ? icon : <i className="icon-nameLocation1" />}
      <span className="text-sm ">
        {state?.name ?? state?.title ?? state ?? ''} ,{' '}
        {city?.name ?? city?.title ?? city ?? ''} {address ?? ''}
      </span>
    </div>
  );
};

export default Location;
